// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"766":"f772d98a","814":"e44fe938"}[chunkId] + ".js";
};